import { SalesGateway } from "./SaleRecord.ts";

export const SalesStatisticsScreenPath = "/admin/sales-statistics";

export const GATEWAY_URL_PARAM = "gateway";

export function salesStatisticsPathFor(gateway?: SalesGateway): string {
  return gateway
    ? `${SalesStatisticsScreenPath}?${GATEWAY_URL_PARAM}=${gateway}`
    : SalesStatisticsScreenPath;
}
